import React from 'react';
import { NewsItem } from '../../../domain/entities';

interface PlayerNewsPanelProps {
    playerNews: NewsItem[];
    onSelectNews: (item: NewsItem) => void;
}

export const PlayerNewsPanel: React.FC<PlayerNewsPanelProps> = ({ playerNews, onSelectNews }) => {
    return (
        <div className="panel">
            <div className="panel-header">Player News</div>
            <div className="panel-content">
                {playerNews.length > 0 ? (
                    <div className="table-wrapper" style={{ maxHeight: '250px', overflowY: 'auto' }}>
                        <ul style={{ listStyle: 'none', padding: '0', margin: '0' }}>
                            {playerNews.map(item => (
                                <li key={item.id} onClick={() => onSelectNews(item)} className="player-news-list-item">
                                    <div style={{ fontWeight: !item.isRead ? 'bold' : 'normal', color: !item.isRead ? 'var(--accent-text-color)' : 'inherit', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={item.title}>{item.title}</div>
                                    <div style={{ fontSize: '0.9em', opacity: 0.7 }}>S{item.season} W{item.week}</div>
                                </li>
                            ))}
                        </ul>
                    </div>
                ) : (
                    <p className="text-secondary">No news items found for this player.</p>
                )}
            </div>
        </div>
    );
};
